<div class="flex flex-col gap-2 w-full">
    <p-ifta-label>
        <p-iconfield>
            <p-inputicon class="pi pi-upload"></p-inputicon>
            <input #fileInput (change)="onFileSelected($event)" accept=".bin" hidden type="file"/>

            <!-- Visible input to show filename -->
            <input pInputText type="text" [value]="fileName || ''" readonly (click)="triggerFileSelect(fileInput)"
                   class="cursor-pointer w-full" style="padding-right: 4.5rem;"/>

            <!-- Spinner icon -->
            @if (uploading) {
                <span (click)="triggerFileSelect(fileInput)" class="p-inputgroup-addon"
                      style="cursor: pointer; position: absolute; right: 1rem; top: 60%; transform: translateY(-50%);">
          <i class="pi pi-spin pi-spinner"></i>
        </span>
            }

            <!-- Remove icon -->
            @if (fileName) {
                <span (click)="removeFile(); $event.stopPropagation()" class="p-inputgroup-addon"
                [ngStyle]="{
            cursor: 'pointer',
            position: 'absolute',
            right: uploading ? '2.3rem' : '1rem',
            top: '60%',
            transform: 'translateY(-50%)'
            }">
          <i class="pi pi-times"></i>
        </span>
            }
        </p-iconfield>
        <label for="sample-firmware-revision-release-version">Firmware Revision .bin File <span
                class="text-red-500">*</span></label>
    </p-ifta-label>
</div>